import React, { useState } from 'react';
import { linksData } from '../../data/knowledgeBank/linksData';
import { FiLink, FiExternalLink, FiChevronDown, FiChevronUp } from 'react-icons/fi';

export default function Links() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Important <span>Links</span></h1>
        <p>Reference directories, government portals, tax websites, and compliance links</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container" style={{ maxWidth: '1000px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {linksData.map((category, index) => {
              const isOpen = openIndex === index;
              return (
                <div 
                  key={category.id} 
                  style={{ 
                    background: 'var(--white)',
                    border: '1px solid var(--gray-200)',
                    borderRadius: 'var(--radius-md)',
                    overflow: 'hidden',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    style={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      padding: '20px 24px',
                      background: isOpen ? 'var(--primary)' : 'var(--white)',
                      color: isOpen ? 'var(--white)' : 'var(--text-dark)',
                      border: 'none',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'all 0.3s ease',
                      borderBottom: 'none'
                    }}
                    onMouseEnter={(e) => {
                      if (!isOpen) {
                        e.currentTarget.style.background = 'var(--primary)';
                        e.currentTarget.style.color = 'var(--white)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isOpen) {
                        e.currentTarget.style.background = 'var(--white)';
                        e.currentTarget.style.color = 'var(--text-dark)';
                      }
                    }}
                  >
                    <h2 
                      style={{ 
                        fontSize: '1.25rem', 
                        color: 'inherit', 
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        margin: 0,
                        fontWeight: 600
                      }}
                    >
                      <FiLink size={20} /> {category.name}
                    </h2>
                    {isOpen ? <FiChevronUp size={24} color="currentColor" /> : <FiChevronDown size={24} color="currentColor" />}
                  </button>

                  {isOpen && (
                    <div style={{ padding: '24px' }}>
                      <ul 
                        style={{ 
                          display: 'grid', 
                          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
                          gap: '16px',
                          margin: 0,
                          padding: 0,
                          listStyle: 'none'
                        }}
                      >
                        {category.links.map((link, idx) => (
                          <li 
                            key={idx} 
                            style={{ 
                              background: 'var(--white)',
                              border: '1px solid var(--gray-200)',
                              borderRadius: 'var(--radius-sm)',
                              padding: '12px 16px',
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                              e.currentTarget.style.borderColor = 'var(--primary)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)';
                              e.currentTarget.style.borderColor = 'var(--gray-200)';
                            }}
                          >
                            <a 
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ 
                                color: 'var(--text-dark)',
                                fontWeight: 500,
                                fontSize: '0.95rem',
                                textDecoration: 'none',
                                display: 'block',
                                flex: 1,
                                paddingRight: '10px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}
                              title={link.name}
                            >
                              {link.name}
                            </a>
                            <a 
                              href={link.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ 
                                color: 'var(--secondary)', 
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: 'rgba(13, 202, 240, 0.1)',
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                transition: 'background 0.2s ease'
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(13, 202, 240, 0.2)'}
                              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(13, 202, 240, 0.1)'}
                            >
                              <FiExternalLink size={14} />
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </main>
    </div>
  );
}
